export const pricingPlans = [
    {
        id: 1,
        name: "Basic",
        price: "$29/w",
        saveAmount: "$10",
        features: [
            "Access to basic English conversation lessons",
            "Limited access to practice exercises",
            "Email support"
        ]
    },
    {
        id: 2,
        name: "Standard",
        price: "$49/m",
        saveAmount: "$20",
        features: [
            "Access to intermediate and advanced spoken English courses",
            "Full access to practice exercises",
            "Weekly live group sessions",
            "Email and chat support"
        ]
    },
    {
        id: 3,
        name: "Premium",
        price: "$99/y",
        saveAmount: "$30",
        features: [
            "Access to all spoken English courses and materials",
            "Personalized coaching sessions",
            "Unlimited live group sessions",
            "24/7 email, chat, and phone support",
            "Exclusive access to additional resources"
        ]
    }
];
